import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";
import axios, { AxiosError } from "axios";
import { useMatch, useNavigate ,useLocation } from "react-router-dom";

// Define the shape of context data
interface PollingContextType {
  data: any; // Replace with your actual data type
  error: Error | null;
}

// Create the context
const PollingContext = createContext<PollingContextType | undefined>(undefined);

interface PollingProviderProps {
  children: ReactNode;
}

// Provider component
export const PollingProvider: React.FC<PollingProviderProps> = ({ children }) => {
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<Error | null>(null);
  const navigate = useNavigate();
const location = useLocation();
  const fetchData = async () => {
    try {
      const response = await axios.get("/accounts/is_auth", {
        withCredentials: true,
      });
      if (response && response.status === 200) {
        setData(response.data);
        setError(null);
      } else {
        // treat non-200 as not authenticated
        navigate("/login");
      }
    } catch (err: unknown) {
      console.log('Polling fetch error', err);
      // Properly handle axios errors (401 -> redirect to login)
      if (axios.isAxiosError(err)) {
        if (err.response?.status === 401) {
          navigate("/login");
          return;
        }
      }

      if (err instanceof Error) {
        console.error("General error:", err);
        setError(err);
      } else {
        console.error("Unknown error", err);
        setError(new Error("Unknown error occurred"));
      }
    }
  };
//   const match = useMatch("/confirm/:uid/:token/");

    
useEffect(() => {
  // Exclude these exact paths from polling
  const excludedExact = ["/login", "/otp", "/forget-password", "/logout", "/ChangePassword"];

  // Exclude any confirm routes (dynamic) like /confirm or /confirm/:uid/:token
  const isConfirmRoute = location.pathname === '/confirm' || location.pathname.startsWith('/confirm/');

  const shouldPoll = !excludedExact.includes(location.pathname) && !isConfirmRoute;

  if (!shouldPoll) return;

  fetchData();

  const intervalId = setInterval(() => {
    fetchData();
  }, 60 * 1000);

  return () => clearInterval(intervalId);
}, [location.pathname]); // Add location.pathname as dependency

  return (
    <PollingContext.Provider value={{ data, error }}>
      {children}
    </PollingContext.Provider>
  );
};

// Custom hook for consuming the context
export const usePolling = (): PollingContextType => {
  const context = useContext(PollingContext);
  if (!context) {
    throw new Error("usePolling must be used within a PollingProvider");
  }
  return context;
};
